//Berechnet Daten für sum

//function sumUp all

export const sumAllEnergy = (timeSpan, sensorData, availableEnergie) => {
    let dataHolder;
    let sumIn = 0;
    let sumOut = 0;
    let total = 0;
    sensorData.map( (sensorData, index)  => {
        dataHolder = splitData (sensorData, availableEnergie, timeSpan);
       
        
        for (let [key, value] of Object.entries(dataHolder)) {   
            
            if (value.powerType === "NOPOWER"){

            } else {
                
                if (value.energyDirection == 1) {
                    sumIn = sumIn + value.energyKWh;
                } else {
                    sumOut = sumOut + value.energyKWh;
                }
            }
            
        }
    })
    total = sumIn + sumOut;
    return {
        'sumIn': sumIn,
        'sumOut': sumOut,
        'total': total,
    }
}

export const getData = (value, CASE, availableEnergie) => {
    let powerType;
    let color;
    let energyKWh;
    let energyDirection;

    if(value[CASE] !== undefined && value[CASE].energyKWh !== undefined)
    {
        powerType = value[CASE].sourcePowerType;
        energyKWh = value[CASE].energyKWh;
        
        if (energyKWh == 0) {
            return {
                "success": false,
                "data": 0
            };
        }
        if (energyKWh >= 0) {
            energyDirection = 1;
        }else {
            energyDirection = -1;
            energyKWh = Math.abs(energyKWh);
        }

    }else {
        return {
            "success": false,
            "data": 0
        };
    }

    for (let [key, value] of Object.entries(availableEnergie)) {
        if (key == powerType) {
            color = '#'+value.color;
            break;
        }            
    }

    energyKWh = parseFloat(energyKWh);
    
    return {
        "success": true,
        "data": {powerType: powerType, color: color, energyKWh: energyKWh, energyDirection: energyDirection}
    };
}

export const splitData = (rectangle, availableEnergie, timeSpan) => {

    

    let dataHolder= [];
    let correctData;
    for (let [key, value] of Object.entries(rectangle)) {   
        if(timeSpan !== undefined) {
            switch(timeSpan) {
                case 'Stunde':
                    correctData = getData(value, 'HOURLY', availableEnergie);
                    if (correctData.success) {
                        dataHolder.push(correctData.data);
                    }
                break;
                case 'Tag':
                    correctData = getData(value, 'DAILY', availableEnergie);
                    if (correctData.success) {
                        dataHolder.push(correctData.data);
                    }
                break;
                case 'Monat':
                    correctData = getData(value, 'MONTHLY', availableEnergie);
                    if (correctData.success) {
                        dataHolder.push(correctData.data);
                    }
                break;
                case 'Jahr':
                    correctData = getData(value, 'YEARLY', availableEnergie);
                    if (correctData.success) {
                        dataHolder.push(correctData.data);
                    }
                break;
                case 'Total':
                    correctData = getData(value, 'TOTAL', availableEnergie);
                    if (correctData.success) {
                        dataHolder.push(correctData.data);
                    }
                break;
                default:
            }
            
        }  
    }

    return dataHolder;
}